import { render, staticRenderFns } from "./AutoPostingToXSetting.vue?vue&type=template&id=5ac4146a&scoped=true&"
import script from "./AutoPostingToXSetting.vue?vue&type=script&lang=ts&"
export * from "./AutoPostingToXSetting.vue?vue&type=script&lang=ts&"
import style0 from "./AutoPostingToXSetting.vue?vue&type=style&index=0&id=5ac4146a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac4146a",
  null
  
)

export default component.exports